<template>
  <mdb-container>
    <mdb-col v-if="showSpinner">
      <Spinner />
    </mdb-col>
    <mdb-row>
      <UserForm @user-created="onUserCreated" />
    </mdb-row>

    <mdb-row>
      <UserList :users="users" />
    </mdb-row>
  </mdb-container>
</template>

<script>
import api from "@/api";
import Spinner from "@/components/Spinner";
import UserForm from "@/components/UserForm";
import UserList from "@/components/UserList";
import { mdbRow, mdbCol, mdbContainer } from "mdbvue";

export default {
  name: "UsersConfig",
  components: {
    mdbRow,
    mdbCol,
    mdbContainer,
    Spinner,
    UserForm,
    UserList,
  },
  data() {
    return {
      users: [],
      isLoading: true,
    };
  },

  computed: {
    showSpinner() {
      return this.isLoading;
    },
  },
  created() {
    this.isLoading = false;
    this.getUserList();
    this.isLoading = false;
  },
  methods: {
    onUserCreated(userInfo) {
      this.getUserList();
    },

    getUserList() {
      api
        .getUserList()
        .then((response) => {
          this.users.splice(0, this.users.length, ...response.data);
          this.isLoading = false;
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
};
</script>

<style scoped lang="scss"></style>
